// @ts-nocheck
import { motion } from 'framer-motion';
import { Text, XStack, YStack } from 'tamagui';

import { useIsMobile } from '../../hooks/useIsMobile';
import { useMotion } from '../../hooks/useMotion';
import { SubscribeForm } from './SubscribeForm';

export function Hero() {
  const isMobile = useIsMobile();
  const { heroStagger } = useMotion();

  return (
    <YStack
      paddingTop={isMobile ? 140 : 180}
      paddingBottom={isMobile ? 80 : 120}
      paddingHorizontal="$5"
      backgroundColor="$background"
      maxWidth={1100}
      alignSelf="center"
      width="100%"
    >
      <motion.div {...heroStagger(0)}>
        <Text
          fontSize={isMobile ? 42 : 68}
          fontWeight="700"
          letterSpacing={isMobile ? -1.5 : -2.5}
          lineHeight={isMobile ? 46 : 74}
          color="$color12"
          maxWidth={720}
        >
          One search bar for your entire company.
        </Text>
      </motion.div>

      <motion.div {...heroStagger(1)}>
        <Text
          fontSize={isMobile ? 16 : 20}
          color="$color8"
          maxWidth={520}
          marginTop="$5"
          lineHeight={isMobile ? 26 : 32}
          fontWeight="400"
        >
          Search Gmail, Slack, Notion, Drive, GitHub, and 50 other tools at once — with built-in apps so you can cancel a few subscriptions.
        </Text>
      </motion.div>

      <motion.div {...heroStagger(2)}>
        <YStack marginTop="$6" maxWidth={480}>
          <SubscribeForm />
        </YStack>
      </motion.div>

      <motion.div {...heroStagger(3)}>
        <XStack flexDirection="row" gap="$4" flexWrap="wrap" alignItems="center" marginTop="$5" opacity={0.7}>
          <Text fontSize="$2" color="$color7">50+ integrations</Text>
          <Text fontSize="$1" color="$color5">·</Text>
          <Text fontSize="$2" color="$color7">Permissions-aware search</Text>
          <Text fontSize="$1" color="$color5">·</Text>
          <Text fontSize="$2" color="$color7">Replace 3-4 subscriptions</Text>
        </XStack>
      </motion.div>
    </YStack>
  );
}
